import { render, staticRenderFns } from "./SatisBilgiForm.vue?vue&type=template&id=240b16b2&scoped=true"
import script from "./SatisBilgiForm.vue?vue&type=script&lang=ts"
export * from "./SatisBilgiForm.vue?vue&type=script&lang=ts"
import style0 from "./SatisBilgiForm.vue?vue&type=style&index=0&id=240b16b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240b16b2",
  null
  
)

export default component.exports